// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardPaidStatusCard_root__QlOsc","text":"PlasmicDashboardPaidStatusCard_text__+wKHa"};